import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, queryAssignedElements } from 'lit/decorators.js';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';
import componentStyles from './idb-multistep-container.css.lit';
import { IdbMultistepCard } from '../idb-multistep-card/idb-multistep-card';

@customElement('idb-multistep-container')
export class IdbMultistepContainer extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @queryAssignedElements({ slot: 'cards' })
  cards: IdbMultistepCard[];

  updated() {
    this.cards.map((card, index) => {
      if (this.cards.length > 1) {
        if (index === 0) {
          return card.setAttribute('position', 'first');
        }
        if (index === this.cards.length - 1) {
          return card.setAttribute('position', 'last');
        }
      } else if (this.cards.length === 1) {
        return card.setAttribute('position', 'single');
      }
    });
  }

  render(): TemplateResult {
    return html`
      <div class="multistep-container">
        <slot name="cards"></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'idb-multistep-container': IdbMultistepContainer;
  }
}
